import { cn } from "@/lib/utils";
import { toneFor, title } from "@/lib/format";

export function StatusBadge({ value, label, className, testId }) {
  return (
    <span
      data-testid={testId}
      className={cn(
        "inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-semibold ring-1 ring-inset whitespace-nowrap",
        toneFor(value),
        className
      )}
    >
      {label || title(value) || "—"}
    </span>
  );
}

export function ScoreBadge({ score, testId }) {
  if (score === null || score === undefined) return <span className="text-slate-400">—</span>;
  const n = Number(score);
  const tone =
    n >= 8
      ? "bg-emerald-600 text-white ring-emerald-700/20"
      : n >= 5
        ? "bg-amber-500 text-white ring-amber-600/20"
        : "bg-slate-200 text-slate-700 ring-slate-300";
  return (
    <span
      data-testid={testId}
      className={cn("inline-flex min-w-[2.5rem] justify-center rounded-full px-1.5 py-0.5 font-mono text-xs font-bold ring-1 ring-inset", tone)}
    >
      {n}/10
    </span>
  );
}
